import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WelcomeDialogComponent } from './welcome-dialog.component';
import { WelcomeStepComponent } from './welcome/welcome-step.component';
import { ChoosePlanComponent } from './choose-plan/choose-plan.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		WelcomeDialogComponent,
		WelcomeStepComponent,
		ChoosePlanComponent
	],
	exports: [
		WelcomeDialogComponent,
		WelcomeStepComponent,
		ChoosePlanComponent
	]
})
export class WelcomeDialogModule {}
